import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTimeSeriesMetric } from "../../api/timeseriesApi";

export const useRelativeMetrics = ({benchmark=null}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [metric, setMetric] = useState('beta');
  const [targetSymbol, setTargetSymbol] = useState(benchmark ? benchmark:'spy');
  const [window, setWindow] = useState(252);
  const [dataPaths, setDataPaths] = useState([]);
  const [isCurrent, setIsCurrent] = useState(false);

  useEffect(()=>{
    setIsCurrent(false);
  }, [metric, targetSymbol, window]);




  const fetchNewData = (symbols, afterFetch, startDate)=>{
    setIsLoading(true)
    dispatch(getTimeSeriesMetric({
        symbols: symbols,
        targetSymbol: targetSymbol,
        metric: metric,
        window: window,
        startDate
      })).then((resp)=>{
        setIsLoading(false)
        setIsCurrent(true);
        afterFetch?.();
    })

  }



  return {
    metric,
    setMetric,
    targetSymbol,
    setTargetSymbol,
    window,
    setWindow,
    dataPaths,
    setIsCurrent,
    isCurrent,
    fetchNewData,
    isLoading

  };
};